<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>市场监察</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="防伪码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否查询失败" prop="ifScanSuccess" label-width="100px">
                <el-select type="text" filterable v-model="searchform.ifScanSuccess" style="width:100%">
                  <el-option
                    v-for="(item,index) in ifScanSuccess"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="查询时间" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="yyyy-MM-dd hh:mm:ss"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['supervise_select']">搜索</el-button>
               <el-button
              v-permission="['supervise_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
            </el-row> 
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>市场监察</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="employee_name" label="稽查人姓名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="account_name" label="稽查人编码" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="查询日期" min-width="140" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="create_data" label="查询时间" min-width="80" show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="address" label="查询地点" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="couuntno" label="查询次数" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="query_method" label="查询方式" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_name" label="产品名称" min-width="200" show-overflow-tooltip ></el-table-column>   <el-table-column prop="batchno" label="批次号" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="防伪码" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freight_bill_code_time" label="出库日期" min-width="160" show-overflow-tooltip ></el-table-column>   <el-table-column prop="freight_bill_code" label="运单号" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer_name" label="送达方名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="addr" label="送达方地址" min-width="180" show-overflow-tooltip ></el-table-column>   
            <!-- <el-table-column prop="memo" label="查询信息" min-width="140" show-overflow-tooltip fixed="right"></el-table-column> -->
            <el-table-column prop="ifflee_good" label="查询结果" min-width="140" show-overflow-tooltip fixed="right"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { check } from "@/api/report";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
     //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据ifScanSuccess
      ifScanSuccess:[
       {
         value:0,
         label:"失败"
       },
       {
         value:1,
         label:"成功"
       }
     ],
     qrcode_status:[
       {
         value:3,
         label:"已下载"
       },
       {
         value:4,
         label:"未下载"
       }
     ],
      searchform: {
        ifScanSuccess:null,
        batchno:null,
        qrcode:null,
        datelist:[],
        srejectedTime:null,
        erejectedTime:null,
        dealer_name: null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      check(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData)
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    // 拼数据
    packdate(obj){
      for (let i = 0; i < obj.length; i++) {
         obj[i].rejected_time = this.$parseTime(obj[i].rejected_time);
        switch (obj[i].query_method) {// 查询方式 .substring(0,obj[i].period_date.replace(/T/, " ").length-8);
          case 0:obj[i].query_method = "网站"           
            break;
            case 1:obj[i].query_method = "APP"           
            break;
          default:
            break;
        }
         switch (obj[i].ifflee_good) {// 查询结果
          case 0:obj[i].ifflee_good = "一致"           
            break;
            case 1:obj[i].ifflee_good = "不一致"           
            break;
          default:
            break;
        }
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          qrcode:this.searchform.qrcode,
          batchno:this.searchform.batchno,
          ifScanSuccess:this.searchform.ifScanSuccess,
        dealer_name:this.searchform.dealer_name,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
          qrcode:this.searchform.qrcode,
          batchno:this.searchform.batchno,
          ifScanSuccess:this.searchform.ifScanSuccess,
        dealer_name:this.searchform.dealer_name,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize,
        currPage:this.searchform.currPage,
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
        //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        ifScanSuccess:this.searchform.ifScanSuccess,
        qrcode:this.searchform.qrcode,
        batchno:this.searchform.batchno,
        dealer_name:this.searchform.dealer_name,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
      };
      check(obj).then(response => {
        this.packdate(response.data.list)
        this.tableDataDownload = response.data.list;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "稽查人姓名",
            "稽查人编码",
            "查询日期",
            "查询地点",
            "查询次数",
            "查询方式",
            "产品名称",
            "批次号",
            "防伪码",
            "出库日期",
            "运单号",
            "送达方名称",
            "送达方地址",
            "查询结果",
          ];
          const filterVal = [
            "employee_name",
            "account_name",
            "create_time",
            "address",
            "qrcodeqty",
            "query_method",
            "product_name",
            "batchno",
            "qrcode",
            "freight_bill_code_time",
            "freight_bill_code",
            "dealer_name",
            "addr",
            "ifflee_good",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>